import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const ResendFamilyInvite = graphql.persisted(
  "ResendFamilyInvite",
  graphql(`mutation ResendFamilyInvite($input: ResendFamilyInviteInput!) {
    resendFamilyInvite(input: $input) {
      familyEnrollment { id }
      userErrors { message path }
    }
  }`)
);

export { ResendFamilyInvite };
export function useResendFamilyInvite() {
  return useMutation(ResendFamilyInvite);
}
